var map = {
	"./365-and-datacamp-comparisson.png": 1379,
	"./365-logo-small-light.png": 1031,
	"./365-logo-small.png": 1380,
	"./about-us-companies.png": 1026,
	"./about-us-our-vision.png": 1028,
	"./about-us-ready-bg.png": 1381,
	"./about-us-students.png": 1382,
	"./about-us.jpg": 1383,
	"./advanced-specialization.png": 1384,
	"./alternative-page.png": 1385,
	"./b2b-img1.jpg": 1032,
	"./b2b-img1.png": 1386,
	"./b2b-img2.jpg": 1033,
	"./b2b-img2.png": 1387,
	"./b2b-img3.jpg": 1034,
	"./b2b-img3.png": 1388,
	"./b2b-img4.jpg": 1035,
	"./b2b-img4.png": 1389,
	"./b2b-img5.jpg": 1036,
	"./b2b-img5.png": 1390,
	"./b2b-img6.jpg": 1037,
	"./b2b-img6.png": 1391,
	"./b2b-preview-image-mobile.jpg": 1038,
	"./b2b-preview-image.jpg": 1039,
	"./background-scholarship-page.jpg": 1392,
	"./bf-background-desktop.jpg": 1393,
	"./bf-background-mobile.jpg": 1394,
	"./blog-banner-users-light.png": 1040,
	"./blog-banner-users-mobile.png": 1041,
	"./blog-banner-users.png": 1395,
	"./business-live-trainings-mobile.png": 1042,
	"./business-live-trainings.png": 1043,
	"./calculators/coefficient-of-variation/cov-01-faq-desktop.png": 1044,
	"./calculators/coefficient-of-variation/cov-02-faq-desktop.png": 1045,
	"./calculators/coefficient-of-variation/cov-03-faq-desktop.png": 1046,
	"./calculators/coefficient-of-variation/cov-04-faq-desktop.png": 1047,
	"./calculators/coefficient-of-variation/cov-05-faq-desktop.png": 1048,
	"./calculators/confidence-interval/confidence-interval-01-desktop.png": 1049,
	"./calculators/confidence-interval/confidence-interval-02-desktop.png": 1050,
	"./calculators/confidence-interval/confidence-interval-03-desktop.png": 1051,
	"./calculators/confidence-interval/confidence-interval-04-desktop.webp": 1052,
	"./calculators/confidence-interval/confidence-interval-05-desktop.png": 1053,
	"./calculators/confidence-interval/confidence-interval-06-desktop.webp": 1054,
	"./calculators/confidence-interval/confidence-interval-07-desktop.png": 1055,
	"./calculators/difference-in-means/dif-in-means-001.webp": 1056,
	"./calculators/difference-in-means/dif-in-means-02-mobile.webp": 1057,
	"./calculators/difference-in-means/dif-in-means-02.webp": 1058,
	"./calculators/difference-in-means/dif-in-means-faq-01.webp": 1059,
	"./calculators/difference-in-means/dif-in-means-faq-02.webp": 1060,
	"./calculators/difference-in-means/dif-in-means-faq-03.webp": 1061,
	"./calculators/difference-in-means/dif-in-means-faq-04.webp": 1062,
	"./calculators/difference-in-means/dif-in-means-faq-05.webp": 1063,
	"./calculators/difference-in-means/dif-in-means-faq-06.webp": 1064,
	"./calculators/difference-in-means/dif-in-means-faq-07.webp": 1065,
	"./calculators/hypothesis-test/hypothesis-test-002.webp": 1066,
	"./calculators/hypothesis-test/hypothesis-test-01.webp": 1067,
	"./calculators/hypothesis-test/hypothesis-test-03.webp": 1068,
	"./calculators/hypothesis-test/hypothesis-test-04-07.webp": 901,
	"./calculators/hypothesis-test/hypothesis-test-05.webp": 1069,
	"./calculators/hypothesis-test/hypothesis-test-06.webp": 1070,
	"./calculators/hypothesis-test/hypothesis-test-08.webp": 1071,
	"./calculators/hypothesis-test/hypothesis-test-09.webp": 1072,
	"./calculators/hypothesis-test/hypothesis-test-11.webp": 1073,
	"./calculators/hypothesis-test/hypothesis-test-12-13.webp": 902,
	"./calculators/hypothesis-test/hypothesis-test-14.webp": 1074,
	"./calculators/hypothesis-test/hypothesis-test-15.webp": 1075,
	"./calculators/hypothesis-test/hypothesis-test-16.webp": 1076,
	"./calculators/hypothesis-test/hypothesis-test-17.webp": 1077,
	"./calculators/hypothesis-test/hypothesis-test2-10.webp": 1078,
	"./calculators/kurtosis/kurtosis-01-desktop.png": 1079,
	"./calculators/kurtosis/kurtosis-02-desktop.png": 1080,
	"./calculators/kurtosis/kurtosis-03-desktop.png": 1081,
	"./calculators/kurtosis/kurtosis-04-desktop.png": 1082,
	"./calculators/kurtosis/kurtosis-05-desktop.png": 1083,
	"./calculators/kurtosis/kurtosis-07-desktop.png": 1084,
	"./calculators/kurtosis/kurtosis-08-desktop.png": 1085,
	"./calculators/kurtosis/kurtosis-faq-01-desktop.png": 1086,
	"./calculators/kurtosis/kurtosis-faq-02-desktop.png": 1087,
	"./calculators/kurtosis/kurtosis-faq-03-desktop.png": 1088,
	"./calculators/kurtosis/kurtosis2-06-desktop.png": 1089,
	"./calculators/linear-regression/linear-regression-01.webp": 1090,
	"./calculators/linear-regression/linear-regression-02.webp": 1091,
	"./calculators/linear-regression/linear-regression-03.webp": 1092,
	"./calculators/linear-regression/linear-regression-04.webp": 1093,
	"./calculators/linear-regression/linear-regression-05.webp": 1094,
	"./calculators/linear-regression/linear-regression-06.webp": 1095,
	"./calculators/linear-regression/linear-regression-08.webp": 1096,
	"./calculators/linear-regression/linear-regression-09.webp": 1097,
	"./calculators/linear-regression/linear-regression-10.webp": 1098,
	"./calculators/linear-regression/linear-regression-11.webp": 1099,
	"./calculators/linear-regression/linear-regression-12.webp": 1100,
	"./calculators/linear-regression/linear-regression-13.webp": 1101,
	"./calculators/linear-regression/linear-regression-14.webp": 1102,
	"./calculators/linear-regression/linear-regression-15.webp": 1103,
	"./calculators/linear-regression/linear-regression-16.webp": 1104,
	"./calculators/linear-regression/linear-regression-17.webp": 1105,
	"./calculators/linear-regression/linear-regression-18.webp": 1106,
	"./calculators/linear-regression/linear-regression-19.webp": 1107,
	"./calculators/linear-regression/linear-regression-20.webp": 1108,
	"./calculators/linear-regression/linear-regression-21.webp": 1109,
	"./calculators/linear-regression/linear-regression-22.webp": 1110,
	"./calculators/linear-regression/linear-regression-24.webp": 1111,
	"./calculators/linear-regression/linear-regression-25.webp": 1112,
	"./calculators/linear-regression/linear-regression2-07.webp": 1113,
	"./calculators/linear-regression/linear-regression2-23.webp": 1114,
	"./calculators/linear-regression/watermark.png": 1115,
	"./calculators/mean-median-mode/mmm-01-desktop.png": 1116,
	"./calculators/mean-median-mode/mmm-02-desktop.png": 1117,
	"./calculators/mean-median-mode/mmm-03-desktop.png": 1118,
	"./calculators/mean-median-mode/mmm-04-desktop.png": 1119,
	"./calculators/mean-median-mode/mmm-05-desktop.png": 1120,
	"./calculators/mean-median-mode/mmm-06-desktop.png": 1121,
	"./calculators/mean-median-mode/mmm-07-desktop.png": 1122,
	"./calculators/mean-median-mode/mmm-faq-01-desktop.png": 1123,
	"./calculators/mean-median-mode/mmm-faq-02-desktop.png": 1124,
	"./calculators/mean-median-mode/mmm-faq-03-desktop.png": 1125,
	"./calculators/mean-median-mode/mmm-faq-04-desktop.png": 1126,
	"./calculators/mean-median-mode/mmm-faq-05-desktop.png": 1127,
	"./calculators/mean-median-mode/mmm-faq-06-desktop.png": 1128,
	"./calculators/mean-median-mode/mmm-faq-07-desktop.png": 1129,
	"./calculators/p-value/p-value-01.webp": 1130,
	"./calculators/p-value/p-value-02.webp": 1131,
	"./calculators/p-value/p-value-03.webp": 1132,
	"./calculators/p-value/p-value-04.webp": 1133,
	"./calculators/p-value/p-value-05.webp": 1396,
	"./calculators/p-value/p-value-10-mobile.webp": 1134,
	"./calculators/p-value/p-value-10.webp": 1135,
	"./calculators/p-value/p-value-12-mobile.webp": 1136,
	"./calculators/p-value/p-value-12.webp": 1137,
	"./calculators/p-value/p-value1-06.webp": 1138,
	"./calculators/p-value/p-value1-07.webp": 1139,
	"./calculators/p-value/p-value1-08.webp": 1140,
	"./calculators/p-value/p-value1-09.webp": 1141,
	"./calculators/p-value/p-value1-11-mobile.webp": 1142,
	"./calculators/p-value/p-value1-11.webp": 1143,
	"./calculators/skewness/skewness-01-desktop.png": 1144,
	"./calculators/skewness/skewness-01-faq-desktop.png": 1145,
	"./calculators/skewness/skewness-02-desktop.png": 1146,
	"./calculators/skewness/skewness-02-faq-desktop.png": 1147,
	"./calculators/skewness/skewness-03-desktop.png": 1148,
	"./calculators/skewness/skewness-03-faq-desktop.png": 1149,
	"./calculators/skewness/skewness-04-faq-desktop.png": 1150,
	"./calculators/skewness/skewness-05-desktop.png": 1151,
	"./calculators/skewness/skewness-05-faq-desktop.png": 1152,
	"./calculators/skewness/skewness-06-desktop.png": 1153,
	"./calculators/skewness/skewness-06-faq-desktop.png": 1154,
	"./calculators/skewness/skewness-07-desktop.png": 1155,
	"./calculators/skewness/skewness-07-faq-desktop.png": 1156,
	"./calculators/skewness/skewness-08-desktop.png": 1157,
	"./calculators/skewness/skewness-09-desktop.png": 1158,
	"./calculators/skewness/skewness-10-desktop.png": 1159,
	"./calculators/skewness/skewness-11-desktop.png": 1160,
	"./calculators/skewness/skewness-12-desktop.png": 1161,
	"./calculators/skewness/skewness-13-desktop.png": 1162,
	"./calculators/skewness/skewness-14-desktop.png": 1163,
	"./calculators/skewness/skewness-15-desktop.png": 1164,
	"./calculators/skewness/skewness-16-desktop.png": 1165,
	"./calculators/skewness/skewness-17-desktop.png": 1166,
	"./calculators/skewness/skewness2-04-desktop.png": 1167,
	"./calculators/skewness/zoomed-first.png": 1168,
	"./calculators/skewness/zoomed-second.png": 1169,
	"./calculators/standard-deviation/sd-01-faq-desktop.png": 1170,
	"./calculators/standard-deviation/sd-02-desktop.png": 1171,
	"./calculators/standard-deviation/sd-02-faq-desktop.png": 1172,
	"./calculators/standard-deviation/sd-03-desktop.png": 1173,
	"./calculators/standard-deviation/sd-03-faq-desktop.png": 1174,
	"./calculators/standard-deviation/sd-04-desktop.png": 1175,
	"./calculators/standard-deviation/sd-04-faq-desktop.png": 1176,
	"./calculators/standard-deviation/sd-05-desktop.png": 1177,
	"./calculators/standard-deviation/sd-05-faq-desktop.png": 1178,
	"./calculators/standard-deviation/sd2-01-desktop.png": 1179,
	"./calculators/standard-deviation/sd2-06-desktop.png": 1180,
	"./campaigns/bf-landing/blog-banner.png": 1397,
	"./campaigns/bf-landing/cards.jpg": 1181,
	"./campaigns/bf-landing/career-tracks.jpg": 1182,
	"./campaigns/bf-landing/certificates.jpg": 1183,
	"./campaigns/bf-landing/exams.jpg": 1184,
	"./campaigns/bf-landing/foot-glitches.png": 1398,
	"./campaigns/bf-landing/hero-glitches.png": 1399,
	"./campaigns/bf-landing/instructors/anastasia.jpg": 903,
	"./campaigns/bf-landing/instructors/andrew.jpg": 904,
	"./campaigns/bf-landing/instructors/bernard.jpg": 905,
	"./campaigns/bf-landing/instructors/danielle.jpg": 906,
	"./campaigns/bf-landing/instructors/davis.jpg": 907,
	"./campaigns/bf-landing/instructors/elitsa.jpg": 908,
	"./campaigns/bf-landing/instructors/giles.jpg": 909,
	"./campaigns/bf-landing/instructors/harpreet.jpg": 910,
	"./campaigns/bf-landing/instructors/ken.jpg": 911,
	"./campaigns/bf-landing/instructors/olivier.jpg": 912,
	"./campaigns/bf-landing/instructors/randy.jpg": 913,
	"./campaigns/bf-landing/instructors/tina.jpg": 914,
	"./campaigns/bf-landing/leaderboard.jpg": 1185,
	"./campaigns/bf-landing/sticky-banner-bg.png": 1400,
	"./campaigns/bf-landing/video-thumb-ahmed.jpg": 915,
	"./campaigns/bf-landing/video-thumb-ernest.jpg": 916,
	"./campaigns/bf-landing/video-thumb-lee.jpg": 917,
	"./campaigns/bf-landing/video-thumb-meghan.jpg": 918,
	"./campaigns/bf-landing/video-thumb-nada.jpg": 919,
	"./campaigns/bf-landing/xp-coins.jpg": 1186,
	"./campaigns/cm-banners/cm-blog-banner-visuals-1.png": 1187,
	"./campaigns/cm-banners/cm-blog-banner-visuals-2.png": 1188,
	"./campaigns/cm-banners/cm-blog-banner-visuals-3.png": 1189,
	"./campaigns/cm-banners/cm-blog-banner-visuals-4.png": 1190,
	"./campaigns/cm-banners/cyber-monday-blog-banner.png": 1191,
	"./campaigns/cyber-monday-landing/backgrounds/banner-bg.jpg": 1192,
	"./campaigns/cyber-monday-landing/backgrounds/card-bg.png": 1193,
	"./campaigns/cyber-monday-landing/backgrounds/cm-hero-bg1-mobile.png": 1194,
	"./campaigns/cyber-monday-landing/backgrounds/cm-hero-bg2-mobile.png": 1195,
	"./campaigns/cyber-monday-landing/backgrounds/curriculum-bg-mobile.png": 1196,
	"./campaigns/cyber-monday-landing/backgrounds/curriculum-bg.jpg": 920,
	"./campaigns/cyber-monday-landing/backgrounds/footer-bg-mobile.png": 1197,
	"./campaigns/cyber-monday-landing/backgrounds/footer-bg.jpg": 921,
	"./campaigns/cyber-monday-landing/backgrounds/header-bg.png": 873,
	"./campaigns/cyber-monday-landing/backgrounds/video-bg-mobile.png": 874,
	"./campaigns/cyber-monday-landing/backgrounds/video-bg.jpg": 922,
	"./campaigns/cyber-monday-landing/cm-cards.jpg": 1198,
	"./campaigns/cyber-monday-landing/cm-career-tracks.jpg": 1199,
	"./campaigns/cyber-monday-landing/cm-certificates.jpg": 1200,
	"./campaigns/cyber-monday-landing/cm-exams.jpg": 1201,
	"./campaigns/cyber-monday-landing/cm-leaderboard.jpg": 1202,
	"./campaigns/cyber-monday-landing/cm-xp-coins.jpg": 1203,
	"./campaigns/finance-courses-offer-landing/fc-card-bg.png": 1204,
	"./campaigns/finance-courses-offer-landing/fc-cards.jpg": 1205,
	"./campaigns/finance-courses-offer-landing/fc-career-tracks.jpg": 1206,
	"./campaigns/finance-courses-offer-landing/fc-certificates.jpg": 1207,
	"./campaigns/finance-courses-offer-landing/fc-coins.jpg": 1208,
	"./campaigns/finance-courses-offer-landing/fc-exams.jpg": 1209,
	"./campaigns/finance-courses-offer-landing/fc-footer-bg-mobile.png": 1210,
	"./campaigns/finance-courses-offer-landing/fc-footer-bg.jpg": 923,
	"./campaigns/finance-courses-offer-landing/fc-footer-bottom.jpg": 924,
	"./campaigns/finance-courses-offer-landing/fc-footer-top.png": 1211,
	"./campaigns/finance-courses-offer-landing/fc-leaderboard.jpg": 1212,
	"./campaigns/finance-courses-offer-landing/fc-newsfeed.jpg": 1213,
	"./campaigns/finance-courses-offer-landing/fc-program-stats-bg.jpg": 925,
	"./campaigns/finance-courses-offer-landing/fc-program-stats-mobile-bg.png": 1214,
	"./campaigns/finance-courses-offer-landing/fc-streaks.jpg": 1215,
	"./campaigns/finance-courses-offer-landing/fc-video-bg.jpg": 926,
	"./campaigns/finance-courses-offer-landing/fc-xp.jpg": 1216,
	"./campaigns/finance-courses-offer-landing/hero-bg1-mobile.png": 1217,
	"./campaigns/finance-courses-offer-landing/hero-bg2-mobile.png": 1218,
	"./campaigns/free-days-2023/fd-cards.jpg": 1219,
	"./campaigns/free-days-2023/fd-career-tracks.jpg": 1220,
	"./campaigns/free-days-2023/fd-certificates.jpg": 1221,
	"./campaigns/free-days-2023/fd-coins.jpg": 1222,
	"./campaigns/free-days-2023/fd-exams.jpg": 1223,
	"./campaigns/free-days-2023/fd-leaderboard.jpg": 1224,
	"./campaigns/free-days-2023/fd-newsfeed.jpg": 1225,
	"./campaigns/free-days-2023/fd-streaks.jpg": 1226,
	"./campaigns/free-days-2023/fd-xp.jpg": 1227,
	"./campaigns/future-proof/c-fpc-cards.webp": 1228,
	"./campaigns/future-proof/c-fpc-certificates.webp": 1229,
	"./campaigns/future-proof/c-fpc-exams.webp": 1230,
	"./campaigns/future-proof/c-fpc-leaderboard.webp": 1231,
	"./campaigns/future-proof/c-fpc-tracks.webp": 1232,
	"./campaigns/future-proof/c-fpc-xp.webp": 1233,
	"./campaigns/future-proof/fpc-bg-bottom-banner.webp": 1234,
	"./campaigns/future-proof/fpc-bg-footer-mobile.webp": 927,
	"./campaigns/future-proof/fpc-bg-footer.webp": 928,
	"./campaigns/future-proof/fpc-bg-hero-mobile.webp": 929,
	"./campaigns/future-proof/fpc-bg-hero.webp": 930,
	"./campaigns/future-proof/fpc-proof-bg-blog.webp": 1235,
	"./campaigns/get-future-ready/dsgfr-bg-blog.webp": 1236,
	"./campaigns/get-future-ready/dsgfr-bg-bottom-banner.webp": 1237,
	"./campaigns/get-future-ready/dsgfr-bg-footer-mobile.webp": 931,
	"./campaigns/get-future-ready/dsgfr-bg-footer.webp": 932,
	"./campaigns/get-future-ready/dsgfr-bg-hero-mobile.webp": 933,
	"./campaigns/get-future-ready/dsgfr-bg-hero.webp": 934,
	"./campaigns/get-future-ready/dsgfr-certificate.webp": 1238,
	"./campaigns/get-future-ready/dsgfr-channels.webp": 1239,
	"./campaigns/get-future-ready/dsgfr-clp.webp": 1240,
	"./campaigns/get-future-ready/dsgfr-exams.webp": 1241,
	"./campaigns/get-future-ready/dsgfr-leaderboard.webp": 1242,
	"./campaigns/get-future-ready/dsgfr-projects.webp": 1243,
	"./campaigns/get-future-ready/dsgfr-resume.webp": 1244,
	"./campaigns/get-future-ready/dsgfr-technologies-mobile.webp": 935,
	"./campaigns/get-future-ready/dsgfr-technologies.webp": 936,
	"./campaigns/get-future-ready/dsgfr-tracks.webp": 1245,
	"./campaigns/get-future-ready/dsgfr-xp.webp": 1246,
	"./campaigns/get-future-ready/gfr-bg-bottom-banner.webp": 1247,
	"./campaigns/get-future-ready/gfr-bg-footer-mobile-new.webp": 1248,
	"./campaigns/get-future-ready/gfr-bg-footer.webp": 1249,
	"./campaigns/get-future-ready/gfr-bg-hero-mobile.webp": 1250,
	"./campaigns/get-future-ready/gfr-bg-hero.webp": 1251,
	"./campaigns/get-future-ready/gfr-cards.webp": 1252,
	"./campaigns/get-future-ready/gfr-certificate.webp": 1253,
	"./campaigns/get-future-ready/gfr-channels.webp": 1254,
	"./campaigns/get-future-ready/gfr-clp.webp": 1255,
	"./campaigns/get-future-ready/gfr-coins.webp": 1256,
	"./campaigns/get-future-ready/gfr-exams.webp": 1257,
	"./campaigns/get-future-ready/gfr-leaderboard.webp": 1258,
	"./campaigns/get-future-ready/gfr-projects.webp": 1259,
	"./campaigns/get-future-ready/gfr-streak.webp": 1260,
	"./campaigns/get-future-ready/gfr-tracks.webp": 1261,
	"./campaigns/get-future-ready/gfr-xp.webp": 1262,
	"./campaigns/got-what-it-takes-landing/gwt-blog-banner-bg.jpg": 1263,
	"./campaigns/got-what-it-takes-landing/gwt-cards.jpg": 1264,
	"./campaigns/got-what-it-takes-landing/gwt-career-tracks.jpg": 1265,
	"./campaigns/got-what-it-takes-landing/gwt-certificates.jpg": 1266,
	"./campaigns/got-what-it-takes-landing/gwt-exams.jpg": 1267,
	"./campaigns/got-what-it-takes-landing/gwt-leaderboard.jpg": 1268,
	"./campaigns/got-what-it-takes-landing/gwt-quiz-background.jpg": 1269,
	"./campaigns/got-what-it-takes-landing/gwt-quiz-mobile-bg.jpg": 1270,
	"./campaigns/got-what-it-takes-landing/gwt-sticky-banner.jpg": 1271,
	"./campaigns/got-what-it-takes-landing/gwt-xp-coins.jpg": 1272,
	"./campaigns/instructors/instr-anastasia.jpg": 651,
	"./campaigns/instructors/instr-andrew.jpg": 652,
	"./campaigns/instructors/instr-bernard.jpg": 653,
	"./campaigns/instructors/instr-danielle.jpg": 654,
	"./campaigns/instructors/instr-davis.jpg": 655,
	"./campaigns/instructors/instr-elitsa.jpg": 656,
	"./campaigns/instructors/instr-giles.jpg": 657,
	"./campaigns/instructors/instr-harpreet.jpg": 658,
	"./campaigns/instructors/instr-ken.jpg": 659,
	"./campaigns/instructors/instr-olivier.jpg": 660,
	"./campaigns/instructors/instr-randy.jpg": 661,
	"./campaigns/instructors/instr-tina.jpg": 662,
	"./campaigns/jumpstart-2023-landing/js-cards.jpg": 1273,
	"./campaigns/jumpstart-2023-landing/js-career-tracks.jpg": 1274,
	"./campaigns/jumpstart-2023-landing/js-certificates.jpg": 1275,
	"./campaigns/jumpstart-2023-landing/js-exams.jpg": 1276,
	"./campaigns/jumpstart-2023-landing/js-leaderboard.jpg": 1277,
	"./campaigns/jumpstart-2023-landing/js-xp-coins.jpg": 1278,
	"./campaigns/jumpstart-2023-landing/jumpstart-blog-banner.jpg": 1279,
	"./campaigns/jumpstart-2023-landing/jumpstart-footer-bg-mobile.png": 875,
	"./campaigns/jumpstart-2023-landing/jumpstart-footer-bg.jpg": 937,
	"./campaigns/jumpstart-2023-landing/jumpstart-hero-bg-mobile.png": 1280,
	"./campaigns/jumpstart-2023-landing/jumpstart-hero-bg.jpg": 938,
	"./campaigns/jumpstart-2023-landing/jumpstart-sticky-banner-bg-1920.jpg": 1281,
	"./campaigns/jumpstart-2023-landing/jumpstart-sticky-banner-bg.jpg": 1282,
	"./campaigns/jumpstart-2023-landing/lightning-mobile.png": 1401,
	"./campaigns/jumpstart-2023-landing/lightning.png": 789,
	"./campaigns/one-of-200-landing/oth-blog-banner-bg.jpg": 1283,
	"./campaigns/one-of-200-landing/oth-cards.jpg": 1284,
	"./campaigns/one-of-200-landing/oth-career-tracks.jpg": 1285,
	"./campaigns/one-of-200-landing/oth-certificates.jpg": 1286,
	"./campaigns/one-of-200-landing/oth-exams.jpg": 1287,
	"./campaigns/one-of-200-landing/oth-leaderboard.jpg": 1288,
	"./campaigns/one-of-200-landing/oth-sticky-banner-bg.jpg": 1289,
	"./campaigns/one-of-200-landing/oth-xp-coins.jpg": 1290,
	"./campaigns/top-finance-training/lightning2-mobile.jpg": 1402,
	"./campaigns/top-finance-training/lightning2.jpg": 1403,
	"./campaigns/top-finance-training/tft-bottom-banner-bg-laptop-last-promo.webp": 1291,
	"./campaigns/top-finance-training/tft-bottom-banner-bg-laptop.webp": 1292,
	"./campaigns/top-finance-training/tft-bottom-banner-bg-last-promo.webp": 1293,
	"./campaigns/top-finance-training/tft-bottom-banner-bg.webp": 1294,
	"./campaigns/top-finance-training/tft-cards.webp": 1295,
	"./campaigns/top-finance-training/tft-certificates.webp": 1296,
	"./campaigns/top-finance-training/tft-coins.webp": 1297,
	"./campaigns/top-finance-training/tft-exams.webp": 1298,
	"./campaigns/top-finance-training/tft-footer-bg-mobile.webp": 1299,
	"./campaigns/top-finance-training/tft-footer-bg.jpg": 1300,
	"./campaigns/top-finance-training/tft-hero-bg.jpg": 1301,
	"./campaigns/top-finance-training/tft-hero-mobile-bg.webp": 939,
	"./campaigns/top-finance-training/tft-leaderboard.webp": 1302,
	"./campaigns/top-finance-training/tft-newsfeed.webp": 1303,
	"./campaigns/top-finance-training/tft-streaks.webp": 1304,
	"./campaigns/top-finance-training/tft-tracks.webp": 1305,
	"./campaigns/top-finance-training/tft-xp-levels.webp": 1306,
	"./campaigns/video-thumbs/vthumb-ahmed.webp": 626,
	"./campaigns/video-thumbs/vthumb-ernest.webp": 627,
	"./campaigns/video-thumbs/vthumb-lee.webp": 628,
	"./campaigns/video-thumbs/vthumb-meghan.webp": 629,
	"./campaigns/video-thumbs/vthumb-nada.webp": 630,
	"./career-track-certificate.png": 1307,
	"./certificate-of-completion.png": 1404,
	"./cfi.jpg": 1405,
	"./codecademy.jpg": 1406,
	"./contacts.png": 1308,
	"./course-library.png": 1407,
	"./course-preview.jpg": 1408,
	"./coursera-img2.jpg": 1409,
	"./data-camp-comparison.png": 1410,
	"./data-camp-img1-fa.jpg": 1411,
	"./data-camp-img1.jpg": 1412,
	"./data-camp-img2.jpg": 1413,
	"./data-science-fundamentals.png": 1414,
	"./data-science-vs-datacamp.png": 1415,
	"./datacamp-alternative-365-certificate.png": 1416,
	"./datacamp-comparison.png": 1417,
	"./datacamp.jpg": 1418,
	"./dataquest-courses.png": 1419,
	"./dataquest-img2.jpg": 1420,
	"./dataquest-vs-365datascience-courses.jpg": 1421,
	"./dataquest.jpg": 1422,
	"./discover-author_Elitsa.jpg": 1423,
	"./discover-author_Iliya.jpg": 1424,
	"./discover-author_Martin.jpg": 1425,
	"./discover-author_Ned.jpg": 1426,
	"./discover-student_Ah_Lam.jpg": 1427,
	"./discover-student_Anuj_Gupta.jpg": 1428,
	"./discover-student_Goodwin_Akpan.jpg": 1429,
	"./discover-student_Harshita_Sharma.jpg": 1430,
	"./discover-student_José_Alvarez.jpg": 1431,
	"./discover-student_Karen_Ann.jpg": 1432,
	"./discover-student_Maher_Nabeel.jpg": 1433,
	"./discover-student_Michael_Erlihson.jpg": 1434,
	"./discover-student_Richard_Banks.jpg": 1435,
	"./discover-student_Vikesh_Reddy.jpg": 1436,
	"./discover-student_Wilma_Berg.jpg": 1437,
	"./ds-pre-footer-projects.webp": 1438,
	"./edx.jpg": 1439,
	"./fa/fa-365-logo-small.png": 1309,
	"./fa/fa-about-us-2.jpg": 1440,
	"./fa/fa-about-us-our-vision.jpg": 1027,
	"./fa/fa-about-us.jpg": 1441,
	"./fa/fa-b2b-img1.png": 1310,
	"./fa/fa-b2b-img2.png": 1311,
	"./fa/fa-b2b-img3.png": 1312,
	"./fa/fa-b2b-img4.png": 1313,
	"./fa/fa-b2b-img5.png": 1314,
	"./fa/fa-b2b-img6.png": 1315,
	"./fa/fa-b2b-preview-image-mobile.jpg": 1316,
	"./fa/fa-b2b-preview-image.jpg": 1317,
	"./fa/fa-career-track-certificate.png": 1318,
	"./fa/fa-contacts.jpg": 1319,
	"./fa/fa-courses-banner-mobile.jpg": 1442,
	"./fa/fa-courses-banner.jpg": 1443,
	"./fa/fa-guidelines-wall.jpg": 1444,
	"./fa/fa-homepage-hero-image.webp": 1445,
	"./fa/fa-landing/fa-business-group-waving.webp": 588,
	"./fa/fa-landing/fa-city-shadows-mobile.jpg": 1320,
	"./fa/fa-landing/fa-city-shadows.jpg": 1321,
	"./fa/fa-landing/fa-free-offer-upgrade-bg.jpg": 1322,
	"./fa/fa-landing/fa-free-offer-upgrade-mobile-bg.jpg": 1323,
	"./fa/fa-landing/fa-platform-snaps-mobile.png": 876,
	"./fa/fa-landing/fa-platform-snaps.png": 877,
	"./fa/fa-landing/fa-resources-center-offer-bg.jpg": 1324,
	"./fa/fa-landing/fa-resources-center-offer-mobile-bg.jpg": 1325,
	"./fa/fa-landing/fa-signup-mobile.jpg": 1326,
	"./fa/fa-landing/fa-start-learning-bg.jpg": 1327,
	"./fa/fa-landing/fa-start-learning-m-bg.jpg": 1328,
	"./fa/fa-landing/fa-start-learning-m-mobile-bg.jpg": 1329,
	"./fa/fa-landing/fa-start-learning-mobile-bg.jpg": 1330,
	"./fa/fa-landing/fa-students-reviews.png": 808,
	"./fa/fa-login-bg.jpg": 1446,
	"./fa/fa-pre-footer-homepage.jpg": 1447,
	"./fa/fa-pre-footer-homepage.webp": 1448,
	"./fa/fa-pre-footer-projects.webp": 1449,
	"./fa/fa-pre-footer.webp": 545,
	"./fa/fa-signup-bg.jpg": 631,
	"./fa/fa-signup-users.png": 1331,
	"./fa/fa-something-better-bg.jpg": 1450,
	"./fa/fa-you-missed-it-bg.jpg": 1451,
	"./facebook_open_graph.png": 1452,
	"./first-place.png": 1453,
	"./for-business-block.png": 1454,
	"./founder-image.png": 1332,
	"./founder-sign.png": 1333,
	"./free-data-science-month.jpg": 1455,
	"./globuses.png": 1456,
	"./guidelines-mobile.jpg": 1457,
	"./guidelines-wall.jpg": 1458,
	"./hero-campaign-banner-bg.jpg": 1459,
	"./hero-campaign-bg-mobile.jpg": 1334,
	"./hero-campaign-bg.jpg": 1335,
	"./hero-testimonials.jpg": 1460,
	"./icon-chart-blur.png": 484,
	"./icon-lp-coin.png": 586,
	"./icon-python-calc.png": 578,
	"./icon-python.png": 587,
	"./icon-quote-testimonial-story.png": 1461,
	"./icon-quote-testimonials.png": 1462,
	"./icon-quotes.png": 1463,
	"./icon-r-calc.png": 579,
	"./icon-r.png": 483,
	"./icon-video-cc.png": 1464,
	"./join-bg.png": 1465,
	"./landing-page-bg.jpg": 1466,
	"./landing-page-mobile-bg.jpg": 1467,
	"./landing-page-resources-bg.jpg": 1468,
	"./landing-page-resources-mobile-bg.jpg": 1469,
	"./landing/lpage-cards-2.png": 878,
	"./landing/lpage-career-tracks-2.png": 879,
	"./landing/lpage-certificates-2.png": 880,
	"./landing/lpage-coins-2.png": 881,
	"./landing/lpage-exams-2.png": 882,
	"./landing/lpage-leaderboard-2.png": 883,
	"./landing/lpage-newsfeed-2.png": 884,
	"./landing/lpage-streaks-2.png": 885,
	"./landing/lpage-xp-levels-2.png": 886,
	"./linkedIn-learning.jpg": 1470,
	"./live-trainings.jpg": 1471,
	"./login-bg.png": 1472,
	"./lp-instructors.png": 887,
	"./machine-and-deep-learning-in-python.png": 1473,
	"./module-2-programming-for-data-science.png": 1474,
	"./platform-snaps-mobile.png": 1336,
	"./platform-snaps.png": 1337,
	"./pluralsight.jpg": 1475,
	"./polygons-2.png": 1476,
	"./pre-footer-icons-dark.webp": 527,
	"./pre-footer-icons.webp": 546,
	"./professionals-mobile.png": 1477,
	"./professionals-mobile.webp": 1478,
	"./professionals.png": 1479,
	"./professionals.webp": 1480,
	"./quote.png": 1481,
	"./resource-students.png": 1482,
	"./scholarship-image.png": 1483,
	"./screens-ken.png": 1360,
	"./screens-tina.png": 1361,
	"./second-place.png": 1484,
	"./signup-bg.webp": 632,
	"./signup-users.png": 560,
	"./simplilearn.jpg": 1485,
	"./single-polygon-2.png": 1486,
	"./something-better-bg.jpg": 1487,
	"./sprinboard.jpg": 1488,
	"./spring-sale-bg-mobile.jpg": 1029,
	"./spring-sale-bg.jpg": 785,
	"./start-your-career.webp": 700,
	"./students-worldwide-mobile.png": 1489,
	"./students-worldwide.png": 1490,
	"./students.png": 790,
	"./summer-sale-bg-mobile.jpg": 888,
	"./third-place.png": 1491,
	"./treehouse.jpg": 1492,
	"./types-of-learning.png": 1493,
	"./upsell-bg-mobile.jpg": 1338,
	"./upsell-bg.jpg": 1339,
	"./users-group-big.png": 940,
	"./users-group-bigger.png": 1340,
	"./webinar.jpg": 1341,
	"./winter-campaign-banner.jpg": 1494,
	"./winter-special-bg.jpg": 1342,
	"./winter-special-mobile-bg.jpg": 1343,
	"./you-missed-it-bg.jpg": 1495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 650;